import React from 'react';
import {
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select
} from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { validations } from '@shared/infrastructure/ui/validations';
import { Topic } from '@shared/domain/topic/topic.aggregate';
import { Therapy } from '@shared/domain/therapy/therapy.aggregate';

export const TopicSettings = ({
  therapies,
  control,
  disableTherapy
}: {
  therapies: Therapy[];
  control: Control<Topic, any>;
  disableTherapy?: boolean;
}) => {
  return (
    <Controller
      name='therapyId'
      control={control}
      rules={validations.required()}
      render={({ field, fieldState }) => (
        <FormControl>
          <InputLabel error={!!fieldState.error} id='contents-label'>
            Therapy
          </InputLabel>
          <Select
            {...field}
            error={!!fieldState.error}
            labelId='contents-label'
            sx={{ my: '0.3rem' }}
            disabled={disableTherapy}
            input={<OutlinedInput error={!!fieldState.error} label='Therapy' />}
            renderValue={(value) => (
              <div>{therapies.find((c) => c.id === value)?.nameLanguage}</div>
            )}
          >
            {[...therapies]
              .sort((c1, c2) => c1.name.localeCompare(c2.name))
              .map((therapy) => (
                <MenuItem key={therapy.id} value={therapy.id}>
                  <div>{therapy?.nameLanguage}</div>
                </MenuItem>
              ))}
          </Select>
          <FormHelperText error={!!fieldState.error}>
            {fieldState.error?.message}
          </FormHelperText>
        </FormControl>
      )}
    />
  );
};
